<template>
  <div
    class="login-container">
    <div class="login-weaper  animated bounceInDown">
      <div class="login-left">
        <img
          class="img"
          src="@/assets/logo1.png"
          alt="">
        <p class="title">帮助1亿学生学好英语</p>
      </div>
      <div class="login-border">
        <div class="login-main">
          <userLogin v-if="activeName==='user'"></userLogin>
          <ResetPwd v-if="activeName==='resetPwd'"></ResetPwd>
          <a-row :gutter="16" v-if="activeName==='user'" >
            <a-col :span="12"><a @click="goResetPwd" style="color:#409eff;">忘记密码？</a></a-col>
          </a-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 动画
import '@/styles/animate/vue-transition.scss'
import '@/styles/login.scss'
import userLogin from './userlogin'
import ResetPwd from './ResetPassword'
export default {
  name: 'Login',
  components: {
    userLogin,
    ResetPwd
  },
  data () {
    return {
      activeName: 'user'
    }
  },
  created () {
  },
  methods: {
    showLogin () {
      this.activeName = 'user'
    },
    goResetPwd () {
      this.activeName = 'resetPwd'
    }
  }
}
</script>
